import { forwardRef, Fragment } from "react"
import { Icon, Input } from "@mui/material"
import Icons from "../../assets/js/Icons"

const SearchInput = forwardRef(({ onChangeFun,onSearch  ,placeholder}, ref) => {
  const handleKeyPress = (e) => {
    if (e.key === "Enter" && onSearch) {
      e.preventDefault()
      onSearch(e.target.value) 
    }
  }
  return (
    <Fragment>
      <Input
        sx={{
          p: "8px 8px",
          width: "100%",
          bgcolor: "white",
          border: "1px solid #DADADA",
          ":after": { display: "none" },
          ":before": { display: "none" },

          "input": {
            p: "0",
            color: "#110e24",
            fontSize: "15px",
            fontFamily: "Poppins",
          },
        }}
        startAdornment={
          <Icon sx={{ fontSize: "18px", mr: 1, color: "#858585" }}>
            <Icons.Search />
          </Icon>
        }
        type="text"
        name="search"
        inputRef={ref}
        placeholder={placeholder || "Search"}
        onChange={onChangeFun || null}
          onKeyDown={handleKeyPress}
      />
    </Fragment>
  )
})

export default SearchInput